import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e78f561"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-[#141a24] border border-gray-700 rounded-xl shadow-2xl w-full max-w-lg overflow-hidden" }
const _hoisted_2 = { class: "px-5 py-4 border-b border-gray-700 flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-white font-semibold text-base" }, "Clôturer la caisse", -1))
const _hoisted_4 = { class: "text-[11px] text-gray-500 mt-0.5" }
const _hoisted_5 = { class: "p-5 space-y-4" }
const _hoisted_6 = { class: "bg-[#0D181C] border border-gray-800/60 rounded-lg overflow-hidden" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2.5 bg-black/30 text-[11px] font-medium uppercase tracking-wider text-gray-400" }, " Balance calculée ", -1))
const _hoisted_8 = { class: "p-4 space-y-1.5 text-sm" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "Fond d'ouverture", -1))
const _hoisted_11 = { class: "text-white tabular-nums" }
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "+ Billets espèces", -1))
const _hoisted_14 = { class: "text-white tabular-nums" }
const _hoisted_15 = { class: "flex justify-between" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "+ Colis", -1))
const _hoisted_17 = { class: "text-white tabular-nums" }
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "− Remboursements", -1))
const _hoisted_20 = { class: "text-white tabular-nums" }
const _hoisted_21 = { class: "flex justify-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "− Dépenses (incl. carburant/péage)", -1))
const _hoisted_23 = { class: "text-white tabular-nums" }
const _hoisted_24 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "− Primes versées", -1))
const _hoisted_26 = { class: "text-white tabular-nums" }
const _hoisted_27 = {
  key: 1,
  class: "flex justify-between"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "− Taxes véhicules", -1))
const _hoisted_29 = { class: "text-white tabular-nums" }
const _hoisted_30 = { class: "flex justify-between pt-2 border-t border-gray-800 mt-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 font-semibold" }, "Total attendu", -1))
const _hoisted_32 = { class: "text-accent font-semibold tabular-nums" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-[11px] font-medium uppercase tracking-wider text-gray-500 mb-1" }, " Montant compté physiquement (FCFA) ", -1))
const _hoisted_34 = { class: "bg-[#0D181C] border border-gray-800/60 rounded-lg p-4 flex items-center justify-between" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[11px] font-medium uppercase tracking-wider text-gray-500" }, "Écart", -1))
const _hoisted_36 = {
  key: 0,
  class: "text-xs font-normal"
}
const _hoisted_37 = { class: "block text-[11px] font-medium uppercase tracking-wider text-gray-500 mb-1" }
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = { class: "px-5 py-3 bg-black/20 border-t border-gray-700 flex justify-end gap-2" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]

import { ref, computed, watch } from "vue";
	import useCashierSession from "@/composable/useCashierSession";
	import useNotyf from "@/composable/useNotyf";
	import useFormatMoney from "@/composable/useFormatMoney";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'CloseCashierSessionModal',
  props: {
    open: { type: Boolean }
  },
  emits: ["close", "closed"],
  setup(__props: any, { emit: __emit }) {

	/**
	 * Modal de clôture — affiche la balance calculée, demande le montant
	 * compté, montre l'écart en temps réel. Notes obligatoires si écart > 1 FCFA.
	 */
	const props = __props;
	const emit = __emit;

	const notify = useNotyf();
	const { currentSession, currentBreakdown, closeSession, refresh } = useCashierSession();

	const declaredTotal = ref<number | null>(null);
	const notes = ref("");
	const isSubmitting = ref(false);

	const expected = computed(() => Number(currentBreakdown.value?.expected_total ?? 0));
	const discrepancy = computed(() => {
		if (declaredTotal.value == null) return 0;
		return Math.round((Number(declaredTotal.value) - expected.value) * 100) / 100;
	});
	const isExact = computed(() => Math.abs(discrepancy.value) <= 1);
	const needsNote = computed(() => !isExact.value);

	const discrepancyClass = computed(() => {
		if (declaredTotal.value == null) return "text-gray-500";
		if (isExact.value) return "text-emerald-400";
		return discrepancy.value > 0 ? "text-amber-400" : "text-rose-400";
	});

	const discrepancyLabel = computed(() => {
		if (declaredTotal.value == null) return "—";
		if (isExact.value) return "Aucun écart";
		return discrepancy.value > 0 ? "Excédent" : "Manquant";
	});

	// Computed plutôt qu'expression inline dans :placeholder — Vue n'aime
	// pas les apostrophes échappées (`l\'écart`) dans une attribute
	// directive, le compilateur de template casse à la première quote.
	const notesPlaceholder = computed(() =>
		needsNote.value ? "Expliquez l'écart constaté…" : "Optionnel",
	);

	// À chaque ouverture du modal, on rafraîchit la breakdown pour avoir
	// le total expected le plus à jour (le caissier a peut-être fait
	// une vente juste avant d'ouvrir le modal).
	watch(
		() => props.open,
		(o) => {
			if (o) {
				refresh().catch(() => {});
				declaredTotal.value = null;
				notes.value = "";
			}
		}
	);

	const submit = async () => {
		if (!currentSession.value?.uuid) return;
		if (declaredTotal.value == null || declaredTotal.value < 0) {
			notify.error("Montant compté requis");
			return;
		}
		if (needsNote.value && !notes.value.trim()) {
			notify.error("Un commentaire est requis quand un écart est constaté");
			return;
		}

		isSubmitting.value = true;
		try {
			await closeSession(currentSession.value.uuid, {
				declared_total: Number(declaredTotal.value),
				notes: notes.value || undefined,
			});
			notify.success(
				isExact.value
					? "Caisse clôturée — aucune anomalie"
					: `Caisse clôturée — écart ${discrepancy.value} FCFA`
			);
			emit("closed");
			emit("close");
		} catch (err: any) {
			notify.error(err?.data?.response?.message || "Erreur à la clôture");
		}
		isSubmitting.value = false;
	};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.open && _unref(currentSession))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (emit('close')), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("div", null, [
                  _hoisted_3,
                  _createElementVNode("p", _hoisted_4, " Ouverte le " + _toDisplayString(new Date((_unref(currentSession)).opened_at).toLocaleString("fr-FR")), 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
                  class: "text-gray-400 hover:text-white text-xl leading-none"
                }, " × ")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(useFormatMoney)(_unref(currentBreakdown)?.opening_float)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(useFormatMoney)(_unref(currentBreakdown)?.cash_in?.tickets)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(useFormatMoney)(_unref(currentBreakdown)?.cash_in?.packages)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, "−" + _toDisplayString(_unref(useFormatMoney)(_unref(currentBreakdown)?.cash_out?.refunds)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("span", _hoisted_23, "−" + _toDisplayString(_unref(useFormatMoney)(_unref(currentBreakdown)?.cash_out?.expenses)), 1)
                    ]),
                    (Number(_unref(currentBreakdown)?.cash_out?.bonuses ?? 0) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("span", _hoisted_26, "−" + _toDisplayString(_unref(useFormatMoney)(_unref(currentBreakdown)?.cash_out?.bonuses)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (Number(_unref(currentBreakdown)?.cash_out?.vehicle_taxes ?? 0) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("span", _hoisted_29, "−" + _toDisplayString(_unref(useFormatMoney)(_unref(currentBreakdown)?.cash_out?.vehicle_taxes)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(useFormatMoney)(expected.value)) + " FCFA", 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((declaredTotal).value = $event)),
                    type: "number",
                    min: "0",
                    step: "100",
                    placeholder: "0",
                    class: "w-full px-3 py-2 rounded bg-[#0D181C] border border-gray-700 text-white text-lg tabular-nums font-semibold focus:outline-none focus:border-accent"
                  }, null, 512), [
                    [
                      _vModelText,
                      declaredTotal.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", null, [
                    _hoisted_35,
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-xl font-semibold tabular-nums mt-0.5", discrepancyClass.value])
                    }, [
                      _createTextVNode(_toDisplayString(declaredTotal.value != null
										? (discrepancy.value > 0 ? "+" : "") + _unref(useFormatMoney)(discrepancy.value)
										: "—") + " ", 1),
                      (declaredTotal.value != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "FCFA"))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  (declaredTotal.value != null)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["px-3 py-1 rounded-full text-[10px] font-medium uppercase tracking-wider", discrepancyClass.value])
                      }, _toDisplayString(discrepancyLabel.value), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_37, " Commentaire " + _toDisplayString(needsNote.value ? "(obligatoire)" : "(optionnel)"), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((notes).value = $event)),
                    rows: "2",
                    placeholder: notesPlaceholder.value,
                    class: _normalizeClass(["w-full px-3 py-2 rounded bg-[#0D181C] border border-gray-700 text-white text-sm focus:outline-none focus:border-accent", { 'border-amber-500/60': needsNote.value && !notes.value.trim() }])
                  }, null, 10, _hoisted_38), [
                    [_vModelText, notes.value]
                  ])
                ])
              ]),
              _createElementVNode("footer", _hoisted_39, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close'))),
                  disabled: isSubmitting.value,
                  class: "px-4 py-1.5 text-sm text-gray-300 bg-transparent border border-gray-600 rounded hover:bg-gray-700 disabled:opacity-50"
                }, " Annuler ", 8, _hoisted_40),
                _createElementVNode("button", {
                  type: "button",
                  onClick: submit,
                  disabled: isSubmitting.value || declaredTotal.value == null || (needsNote.value && !notes.value.trim()),
                  class: "px-4 py-1.5 text-sm text-white bg-[#219152] rounded hover:bg-[#167841] disabled:bg-gray-600 disabled:opacity-60"
                }, _toDisplayString(isSubmitting.value ? "Clôture…" : "Confirmer la clôture"), 9, _hoisted_41)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})